import { isInEnum } from '@utils/enumerators';

import { EExcludeFromLogsErrors, ERetryWorthErrors, ERROR_CODES, UNRECOGNIZED_ERROR } from '../../constants';
import { IHttpClientError, AxiosErrorExtended } from '../../model';

export const handleError = (error: AxiosErrorExtended): IHttpClientError => {
  if (error.request?.status) {
    return {
      name: error.name,
      stack: error.stack,
      message: error.message,
      code: error.request.status,
    };
  }

  const errorType = ERROR_CODES.find((x) => x.errorCode === error.code);

  return {
    name: error.name,
    stack: error.stack,
    message: error.message,
    code: errorType ? errorType.error : UNRECOGNIZED_ERROR,
  };
};

export const isFaultTolerantError = (error: IHttpClientError): boolean => isInEnum(ERetryWorthErrors, error.code);

export const createErrorInstance = (error: IHttpClientError): Error => {
  const errorInstance = new Error();
  errorInstance.stack = error.stack;
  errorInstance.name = error.name;
  errorInstance.message = error.message;

  return errorInstance;
};

export const isLogWorthy = (error: IHttpClientError): boolean => !isInEnum(EExcludeFromLogsErrors, error.code);
